import { PLATFORM_BY_KEY } from '../constants/platformBranding'

/**
 * Small meeting-provider brand badge (Zoom / Microsoft Teams / Google Meet / Slack).
 * Renders nothing when the provider is absent or unknown, so it's safe to drop next to
 * any meeting title. `provider` is the meetings.provider value ('zoom'|'teams'|'meet'|'slack').
 */
export default function ProviderLogo({ provider, size = 16, title, className = '' }) {
  const platform = provider ? PLATFORM_BY_KEY[provider] : null
  if (!platform) return null
  const label = title ?? platform.label
  return (
    <svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      className={className}
      role="img"
      aria-label={label}
    >
      <title>{label}</title>
      <path d={platform.logoPath} fill={platform.brandColor} />
    </svg>
  )
}
